import { type ModuleApiInfo } from "@client/content/selectors";
import { unwrapResponse } from "@client/lib/api";
import { usePromise } from "@client/lib/hooks";
import { useI18n } from "@common/hooks/i18n";
import { KpiPlainItem } from "@common/modules/affiliate/Widget/Profile/KpiItem";
import { type Data } from "@common/modules/data/types";
import React from "react";
import api from "../../api";
import { type MemberAffiliateDashboard } from "../../types";

export type MapProps = {
  apiInfo: ModuleApiInfo;
  config: Data.SharesConfig;
  cycleEndDate: string;
  currencyCode: string | null | undefined;
  userId: number;
};

export type ActionProps = {
  onClick: () => void;
};

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const [sharePools, isLoading] = usePromise({
    fn: api.getCycleSharePools,
    args: [props.apiInfo, props.cycleEndDate],
    shouldLoad: true
  });

  const sharePool = React.useMemo(
    (): MemberAffiliateDashboard.Api.CycleSharePool =>
      (sharePools ? unwrapResponse(sharePools) : []).find((x) => x.sharePoolId === props.config.pool) ?? {
        cycleEndDate: props.cycleEndDate,
        percentage: 0,
        sharePoolId: "",
        sharePoolName: "",
        shares: 0,
        shareValue: 0,
        volumeTypeKey: ""
      },
    [props.config.pool, sharePools]
  );

  return (
    <KpiPlainItem
      onClick={props.onClick}
      label={props.config.label ?? i18n.shares}
      currencyCode={props.config.type === "price" ? props.currencyCode : null}
      isLoading={isLoading}
      value={props.config.type === "price" ? sharePool.shareValue : sharePool.shares}
    />
  );
};
